import React, { useMemo } from 'react'
// import { Link } from 'react-router-dom'
// import { Button } from '../components/ui'
import './Landing.css'

export const Landing: React.FC = () => {
    // Smart random selection that avoids recent repeats
    const randomImage = useMemo(() => {
        const allImages = [1, 2, 3, 4, 5]

        // Get recently used images from sessionStorage (last 2-3)
        const recentKey = 'landing_image_history'
        const historyStr = sessionStorage.getItem(recentKey) || '[]'
        const recentHistory: number[] = JSON.parse(historyStr)

        // Filter out recently used images
        const availableImages = allImages.filter(img => !recentHistory.includes(img))

        // If all images have been used recently, reset and start fresh
        const imagesToChooseFrom = availableImages.length > 0 ? availableImages : allImages

        // Select randomly from available images
        const randomIndex = Math.floor(Math.random() * imagesToChooseFrom.length)
        const selectedImage = imagesToChooseFrom[randomIndex]

        // Update history (keep last 3)
        const newHistory = [...recentHistory, selectedImage].slice(-3)
        sessionStorage.setItem(recentKey, JSON.stringify(newHistory))

        return `/landing_0${selectedImage}.jpg`
    }, [])

    return (
        <div
            className="landing"
            style={{ backgroundImage: `url('${randomImage}')` }}
        >
            <section className="hero">
                <div className="hero-content">
                    <h1>Modern Artillery Group</h1>
                    {/* <div className="hero-actions">
                        <Link to="/shop">
                            <Button variant="primary" size="lg">
                                SHOP
                            </Button>
                        </Link>
                    </div> */}
                </div>
            </section>
        </div>
    )
}